import ErrorPage from "./ErrorPage";

export default function Error404() {
    return <ErrorPage code={404} message={"Page not found"} />
}
